import { resetFavourites } from '../modules/favourites.js';

function initResources($) {
  
    if ($('.resources-landing').length == 0) {
      return;
    }
    

  var qsRegex;
  var sortValue = 'date';
  var sortAscending = false;
  var $sortSelect = $('.resources-landing .resources-filter__form select[name="sort_by"]');

  function initMobileResourceSelects() {
    if (!window.matchMedia || !window.matchMedia('(max-width: 575.98px)').matches) {
      return;
    }

    var $form = $('.resources-landing .resources-filter__form');
    if ($form.length === 0) {
      return;
    }

    $form.find('select').each(function() {
      var $select = $(this);
      if ($select.data('mobileDropdownInit')) {
        return;
      }
      $select.data('mobileDropdownInit', true);

      var selectId = $select.attr('id') || '';
      var listId = 'nets-select-list-' + (selectId || ('s' + Math.random().toString(36).slice(2, 8)));
      var $wrapper = $('<div class="nets-select" data-select-id="' + selectId + '"></div>');
      var $trigger = $('<button type="button" class="nets-select__trigger" aria-haspopup="listbox" aria-expanded="false" aria-controls="' + listId + '"></button>');
      var $list = $('<div class="nets-select__list" role="listbox" id="' + listId + '"></div>');

      $wrapper.append($trigger, $list);
      $select.after($wrapper);

      function updateTrigger() {
        var text = $select.find('option:selected').text() || $select.find('option').first().text();
        $trigger.text(text);
      }

      function renderOptions() {
        $list.empty();
        $select.find('option').each(function() {
          var $option = $(this);
          var value = $option.attr('value') || '';
          var text = $option.text();
          var isSelected = $option.is(':selected');
          var $item = $('<button type="button" class="nets-select__option" role="option" tabindex="-1"></button>');
          $item.text(text);
          $item.attr('data-value', value);
          $item.attr('aria-selected', isSelected ? 'true' : 'false');
          if (isSelected) {
            $item.addClass('is-selected');
          }
          $list.append($item);
        });
        updateTrigger();
      }

      renderOptions();

      function focusOptionAt(index) {
        var $items = $list.find('.nets-select__option');
        if (!$items.length) return;
        var n = $items.length;
        index = ((index % n) + n) % n;
        $items[index].focus();
      }

      function focusSelectedOption() {
        var $items = $list.find('.nets-select__option');
        var idx = $items.index($list.find('.is-selected')[0]);
        focusOptionAt(idx >= 0 ? idx : 0);
      }

      function openDropdown() {
        $('.nets-select.is-open').not($wrapper).removeClass('is-open').find('.nets-select__trigger').attr('aria-expanded', 'false');
        $wrapper.addClass('is-open');
        $trigger.attr('aria-expanded', 'true');
      }

      function closeDropdown(restoreFocus) {
        $wrapper.removeClass('is-open');
        $trigger.attr('aria-expanded', 'false');
        if (restoreFocus) {
          $trigger[0].focus();
        }
      }

      $trigger.on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        if ($wrapper.hasClass('is-open')) {
          closeDropdown(false);
        } else {
          openDropdown();
          // Defer so the list is shown before focus moves into it.
          window.setTimeout(focusSelectedOption, 0);
        }
      });

      $trigger.on('keydown', function(e) {
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp' || e.key === 'Enter' || e.key === ' ') {
          if (e.key === 'Enter' || e.key === ' ') {
            // Let click handler run via default action, but only when closed.
            if ($wrapper.hasClass('is-open')) {
              return;
            }
          }
          e.preventDefault();
          if (!$wrapper.hasClass('is-open')) {
            openDropdown();
          }
          window.setTimeout(focusSelectedOption, 0);
        }
      });

      $list.on('click', '.nets-select__option', function() {
        var value = $(this).attr('data-value');
        $select.val(value);
        $select.trigger('change');
        renderOptions();
        closeDropdown(true);
      });

      $list.on('keydown', '.nets-select__option', function(e) {
        var $items = $list.find('.nets-select__option');
        var idx = $items.index(this);

        switch (e.key) {
          case 'ArrowDown':
            e.preventDefault();
            focusOptionAt(idx + 1);
            break;
          case 'ArrowUp':
            e.preventDefault();
            focusOptionAt(idx - 1);
            break;
          case 'Home':
            e.preventDefault();
            focusOptionAt(0);
            break;
          case 'End':
            e.preventDefault();
            focusOptionAt($items.length - 1);
            break;
          case 'Enter':
          case ' ':
            e.preventDefault();
            $(this).trigger('click');
            break;
          case 'Escape':
            e.preventDefault();
            closeDropdown(true);
            break;
          case 'Tab':
            // Let Tab move focus naturally, but close the dropdown.
            closeDropdown(false);
            break;
        }
      });

      $select.on('change.mobileSelect', function() {
        renderOptions();
      });
    });

    $(document).off('click.netsSelectResources').on('click.netsSelectResources', function() {
      $('.nets-select.is-open').removeClass('is-open').find('.nets-select__trigger').attr('aria-expanded', 'false');
    });
  }

  function setSortFromSelection(selection) {
    var selected = selection || 'date_desc';
    sortValue = 'date';
    sortAscending = true;
    switch (selected) {
      case 'date_desc':
        sortValue = 'date';
        sortAscending = false;
        break;
      case 'date_asc':
        sortValue = 'date';
        sortAscending = true;
        break;
      case 'title_desc':
        sortValue = 'name';
        sortAscending = false;
        break;
      case 'title_asc':
        sortValue = 'name';
        sortAscending = true;
        break;
    }
  }

  if ($sortSelect.length) {
    setSortFromSelection($sortSelect.val());
  }

  initMobileResourceSelects();

  function buildResourcesFilterUrl() {
    var $form = $('.resources-landing .resources-filter__form');
    if ($form.length === 0) {
      return window.location.pathname + window.location.search + window.location.hash;
    }

    var params = new URLSearchParams(window.location.search);
    var filterKeys = [
      'keyword',
      'resource_category',
      'resource_category[]',
      'fav_only',
      'nets_australia',
      'sort_by',
      'paged',
      'load_more'
    ];

    
    filterKeys.forEach(function(key) {
      params.delete(key);
    });

    var keywordValue = $form.find('input[name="keyword"]').val();
    if (keywordValue) {
      params.set('keyword', keywordValue);
    }

    $form.find('input[name="resource_category[]"]:checked').each(function() {
      params.append('resource_category[]', $(this).val());
    });

    if ($form.find('input[name="fav_only"]').is(':checked')) {
      params.set('fav_only', '1');
    }

    if ($form.find('input[name="nets_australia"]').is(':checked')) {
      params.set('nets_australia', '1');
    }

    if ($sortSelect.length) {
      var sortBy = $sortSelect.val();
      if (sortBy && sortBy !== 'default') {
        params.set('sort_by', sortBy);
      }
    }

    var newUrl = window.location.pathname;
    var queryString = params.toString();
    if (queryString) {
      newUrl += '?' + queryString;
    }
    if (window.location.hash) {
      newUrl += window.location.hash;
    }

    return newUrl;
  }

  function syncResourcesFiltersToUrl() {
    var newUrl = buildResourcesFilterUrl();
    if (!newUrl) {
      return '';
    }
    window.history.replaceState({}, '', newUrl);
    return newUrl;
  }


  // use value of search field to filter
  var $quicksearch = $('.resources-landing .resources-filter__form input').keyup( debounce( function() {

     const keyword_value = $(this).val();

        if (keyword_value.length >= 3) {
          qsRegex = new RegExp( escapeRegExp(keyword_value), 'i' );
        } else {
          qsRegex = null;
        }
        syncResourcesFiltersToUrl();
        $grid.isotope();
        loadMore(initShow);
        renderSelectedFilterChips();
  }, 200 ) );

        var initialKeyword = $('.resources-landing .resources-filter__form input[name="keyword"]').val();
        if (initialKeyword && initialKeyword.length >= 3) {
          qsRegex = new RegExp( escapeRegExp(initialKeyword), 'i' );
        }

  $(".resources-landing .resources-filter__form input[name=\"keyword\"]").on("keydown", function(e) {
    if (e.key === 'Enter') {
      e.preventDefault();
    }
  });

  function clearAllResourceFilters() {
    qsRegex = null;
    var $form = $('.resources-landing .resources-filter__form');
    $form.find('input[type="checkbox"]').prop('checked', false);
    $form.find('input[name="keyword"]').val('');
    if ($sortSelect.length) {
      $sortSelect.val($sortSelect.find('option').first().val());
      setSortFromSelection($sortSelect.val());
    }
    $grid.find(".hidden").removeClass("hidden");
    syncResourcesFiltersToUrl();
    $grid.isotope();
    loadMore(initShow);
    renderSelectedFilterChips();
    updateResultsCount();
  }

  $('.resources-landing .resources-filter__form').on('reset', function() {
    clearAllResourceFilters();
  });

  $('.resources-landing .resources-filter__form input[type="reset"]').on('click', function(e) {
    e.preventDefault();
    clearAllResourceFilters();
  });

  // Mobile-only filter chrome — mirrors the exhibitions page so the
  // resources filter collapses behind a "Filters" toggle on narrow
  // viewports. No-ops on desktop because the matchMedia gates and the
  // CSS hides the relevant elements.
  function initMobileResourcesFilterToggle() {
    if (!window.matchMedia || !window.matchMedia('(max-width: 575.98px)').matches) {
      return;
    }
    var $form = $('.resources-landing .resources-filter__form');
    if ($form.length === 0) {
      return;
    }
    var $toggle = $form.find('.resources-filter__toggle');
    if ($toggle.length === 0 || $toggle.data('initToggle')) {
      return;
    }
    $toggle.data('initToggle', true);

    var $fields = $form.find('.resources-filter__fields');

    function setMobileFilterState(isOpen) {
      $form.toggleClass('is-filters-open', isOpen);
      $toggle.attr('aria-expanded', String(isOpen));

      if ($fields.length) {
        $fields.prop('hidden', !isOpen);
      }

      if (!isOpen) {
        $('.nets-select.is-open').removeClass('is-open').find('.nets-select__trigger').attr('aria-expanded', 'false');
      }
    }

    setMobileFilterState($form.hasClass('is-filters-open'));

    $toggle.on('click.resourcesFilters', function() {
      setMobileFilterState(!$form.hasClass('is-filters-open'));
    });
  }

  function collapseMobileResourcesFilters() {
    if (!window.matchMedia || !window.matchMedia('(max-width: 575.98px)').matches) {
      return;
    }
    var $form = $('.resources-landing .resources-filter__form');
    var $fields = $form.find('.resources-filter__fields');
    $form.removeClass('is-filters-open');
    $form.find('.resources-filter__toggle').attr('aria-expanded', 'false');
    if ($fields.length) {
      $fields.prop('hidden', true);
    }
    $('.nets-select.is-open').removeClass('is-open').find('.nets-select__trigger').attr('aria-expanded', 'false');
  }

  function renderSelectedFilterChips() {
    if (!window.matchMedia || !window.matchMedia('(max-width: 575.98px)').matches) {
      return;
    }

    var $form = $('.resources-landing .resources-filter__form');
    if ($form.length === 0) {
      return;
    }

    var $container = $form.find('[data-selected-filters]');
    if ($container.length === 0) {
      return;
    }

    $container.empty();

    function addChip(label, type, value, ariaLabel) {
      var $chip = $('<span class="resources-filter__chip"></span>');
      var $text = $('<span class="resources-filter__chip-label"></span>').text(label);
      var $remove = $('<button type="button" class="resources-filter__chip-remove"></button>');
      $remove.attr('data-type', type);
      if (value) {
        $remove.attr('data-value', value);
      }
      $remove.attr('aria-label', ariaLabel || 'Remove filter');
      $chip.append($text, $remove);
      $container.append($chip);
    }

    $form.find('input[name="resource_category[]"]:checked').each(function() {
      var value = $(this).val();
      var label = $form.find('label[for="' + $(this).attr('id') + '"] span').text().trim();
      if (label) {
        addChip(label, 'category', value, 'Remove category');
      }
    });

    if ($form.find('input[name="fav_only"]').is(':checked')) {
      addChip('Favourites only', 'fav', '', 'Remove favourites only');
    }

    if ($form.find('input[name="nets_australia"]').is(':checked')) {
      addChip('NETS Australia Resources', 'nets', '', 'Remove NETS Australia resources');
    }

    var keywordValue = ($form.find('input[name="keyword"]').val() || '').trim();
    if (keywordValue) {
      addChip('Keyword : ' + keywordValue, 'keyword', '', 'Remove keyword');
    }

    if ($container.children().length) {
      $container.show();
    } else {
      $container.hide();
    }
  }

  initMobileResourcesFilterToggle();
  renderSelectedFilterChips();

  // Two sort-by selects: one inside the fields wrapper for desktop, one
  // outside it for mobile. Keep them in lock-step so changing either
  // updates the other and the existing sort handler/url-sync code (which
  // reads `select[name="sort_by"]`) sees the new value.
  var $sortMobileSelect = $('.resources-landing select[name="sort_by_mobile"]');
  if ($sortMobileSelect.length && $sortSelect.length) {
    $sortMobileSelect.val($sortSelect.val());
    $sortMobileSelect.on('change.resourcesSortMobile', function() {
      $sortSelect.val($(this).val()).trigger('change');
    });
    $sortSelect.on('change.resourcesSortDesktop', function() {
      $sortMobileSelect.val($(this).val());
    });
  }

  $(document).on('click', '#resources-show-results', function(e) {
    e.preventDefault();
    collapseMobileResourcesFilters();
  });

  $(document).on('click', '.resources-landing [data-clear-filters]', function(e) {
    e.preventDefault();
    clearAllResourceFilters();
    collapseMobileResourcesFilters();
  });

  $(document).on('click', '.resources-filter__chip-remove', function(e) {
    e.preventDefault();

    var $form = $('.resources-landing .resources-filter__form');
    var type = $(this).attr('data-type') || '';
    var value = $(this).attr('data-value') || '';

    if (type === 'category') {
      $form.find('input[name="resource_category[]"][value="' + value + '"]').prop('checked', false);
    }

    if (type === 'fav') {
      $form.find('input[name="fav_only"]').prop('checked', false);
    }

    if (type === 'nets') {
      $form.find('input[name="nets_australia"]').prop('checked', false);
    }

    if (type === 'keyword') {
      $form.find('input[name="keyword"]').val('');
      qsRegex = null;
    }

    renderSelectedFilterChips();
    syncResourcesFiltersToUrl();
    $grid.isotope();
    loadMore(initShow);
  });

  var resourceSessionTimer = null;
  function queueResourceSessionUpdate(idsOverride) {
    if (typeof netsResources === 'undefined' || !netsResources.ajaxUrl) {
      return;
    }
    if (resourceSessionTimer) {
      clearTimeout(resourceSessionTimer);
    }
    resourceSessionTimer = setTimeout(function() {
      var ids = Array.isArray(idsOverride) && idsOverride.length ? idsOverride : getFilteredResourceIds();
      $.post(netsResources.ajaxUrl, {
        action: 'nets_set_resource_results',
        nonce: netsResources.nonce,
        ids: ids,
        source_url: window.location.href
      });
    }, 200);
  }

  function getFilteredResourceIds() {
    if (!iso || !iso.filteredItems) {
      return [];
    }
    return iso.filteredItems.map(function(item) {
      var $item = $(item.element);
      var dataId = parseInt($item.data('resource-id'), 10);
      if (dataId) {
        return dataId;
      }
      var idAttr = $item.attr('id') || '';
      var match = idAttr.match(/post-(\d+)/);
      return match ? parseInt(match[1], 10) : null;
    }).filter(function(id) {
      return !!id;
    });
  }

 $(".resources-landing .resources-filter__form input").on("change", function() {
      // On filter change, reset load more button
      const item_changed = ($(this).attr("name"));
      if (item_changed == 'keyword') {
        // only reload if more then 2 chartacters entered
      }

      var isCheckbox = $(this).attr('type') === 'checkbox';
      var isUnchecked = isCheckbox && !$(this).is(':checked');
      if (isUnchecked) {
        var currentParams = new URLSearchParams(window.location.search);
        var hadServerFilters = currentParams.has('resource_category') || currentParams.has('resource_category[]') || currentParams.has('fav_only') || currentParams.has('nets_australia') || currentParams.has('keyword');
        if (hadServerFilters) {
          var nextUrl = buildResourcesFilterUrl();
          if (nextUrl) {
            window.location.href = nextUrl;
            return;
          }
        }
      }

      // var sortValue = $('#sort_by').val();
      // var sortAscending = true;
      // switch (sortValue) {
      //   case 'date_desc':
      //     sortValue = 'date';
      //     sortAscending = false;
      //     break;
      //   case 'date_asc':
      //     sortValue = 'date';
      //     break;
      //   case 'title_desc':
      //     sortValue = 'name';
      //     sortAscending = false;
      //     break;
      //   case 'title_asc':
      //     sortValue = 'name';
      //     break;
      // }
      $grid.find(".hidden").removeClass("hidden");
      syncResourcesFiltersToUrl();
      loadMore(initShow);
      renderSelectedFilterChips();
      // $grid.isotope('reloadItems').isotope({ filter: '*' });

    });

  $(".resources-landing .resources-filter__form select[name=\"sort_by\"]").on("change", function() {
      setSortFromSelection($(this).val());
      $grid.find(".hidden").removeClass("hidden");
      $grid.isotope({ sortBy: sortValue, sortAscending: sortAscending });
      loadMore(initShow);
      syncResourcesFiltersToUrl();
      renderSelectedFilterChips();
    });

  // debounce so filtering doesn't happen every millisecond
  function debounce( fn, threshold ) {
    var timeout;
    threshold = threshold || 100;
    return function debounced() {
      clearTimeout( timeout );
      var args = arguments;
      var _this = this;
      function delayed() {
        fn.apply( _this, args );
      }
      timeout = setTimeout( delayed, threshold );
    };
  }

  function escapeRegExp(value) {
    return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function prefillFiltersFromUrl() {
    var $form = $('.resources-landing .resources-filter__form');
    var params = new URLSearchParams(window.location.search);
 
    $form.find('input[name="resource_category[]"]').prop('checked', false);
    $form.find('input[name="fav_only"]').prop('checked', false);
    $form.find('input[name="nets_australia"]').prop('checked', false);
 
    if (params.has('keyword')) {
      var keywordValue = params.get('keyword') || '';
      $form.find('input[name="keyword"]').val(keywordValue);
      if (keywordValue.length >= 3) {
        qsRegex = new RegExp( escapeRegExp(keywordValue), 'i' );
      } else {
        qsRegex = null;
      }
    } else {
      $form.find('input[name="keyword"]').val('');
      qsRegex = null;
    }
 
    var categoryParams = getResourceCategoryParamValues(params);
    $form.find('input[name="resource_category[]"]').each(function() {
      var value = String($(this).val() || '').toLowerCase();
      $(this).prop('checked', categoryParams.includes(value));
    });
 
    if (params.has('fav_only')) {
      $form.find('input[name="fav_only"]').prop('checked', true);
    }
 
    if (params.has('nets_australia')) {
      $form.find('input[name="nets_australia"]').prop('checked', true);
    }
 
    if ($sortSelect.length) {
      if (params.has('sort_by')) {
        $sortSelect.val(params.get('sort_by'));
      } else {
        $sortSelect.val($sortSelect.find('option').first().val());
      }
      setSortFromSelection($sortSelect.val());
    }
 
    if ($grid && $grid.length) {
      $grid.isotope('arrange');
    }
  }

  // init Isotope
  prefillFiltersFromUrl();

  function getResourceCategoryParamValues(params) {
    var values = params.getAll('resource_category[]');
    if (!values.length) {
      values = params.getAll('resource_category');
    }
    if (!values.length) {
      var rawQuery = window.location.search.replace(/^\?/, '').split('&');
      rawQuery.forEach(function(pair) {
        if (!pair) {
          return;
        }
        var parts = pair.split('=');
        var key = decodeURIComponent(parts[0] || '');
        if (key === 'resource_category[]' || key === 'resource_category') {
          values.push(decodeURIComponent(parts[1] || ''));
        }
      });
    }
    return values.filter(Boolean).map(function(value) {
      return String(value).toLowerCase();
    });
  }


    // init Isotope
    var $grid = $('.resources-grid__list').isotope({
      itemSelector: 'article',
      layoutMode: 'fitRows',
      fitRows: {
        gutter: 30
      },
      filter: function() {
        var $this = $(this);
        if ($this.hasClass('hidden')) {
          return false;
        }
        var favouritesOnly = $('.resources-landing .resources-filter__form input[name="fav_only"]').is(':checked');
        if (favouritesOnly && !$this.hasClass('is-favourite')) {
          return false;
        }
        var keywordValue = $('.resources-landing .resources-filter__form input[name="keyword"]').val() || '';
        var keywordActive = keywordValue.length >= 3;
        var titleText = $this.attr('data-name') || $this.find('h4').text() || '';
        var cardText = $this.text() || '';
        var searchableText = titleText + ' ' + cardText;
        var searchResult = keywordActive ? searchableText.match( qsRegex ) : true;
        var checkboxFilters = $('.resources-landing .resources-filter__form input[type="checkbox"]:checked');
        var buttonFilter = null;
        if (checkboxFilters.length > 0) {
          var categoryFilters = [];
          checkboxFilters.each(function() {
            var $checkbox = $(this);
            var filterValue = $checkbox.val();
            var filterprefix = $checkbox.data('filterprefix') || false;
            if (filterValue && filterprefix) {
              if (filterprefix === 'filter-category-') {
                categoryFilters.push(filterprefix + filterValue);
              } else {
                var fullFilter = filterprefix + filterValue;
                if ( !$this.is( '.' + fullFilter ) ) {
                  searchResult = false;
                }
              }
            }
          });
          if (categoryFilters.length > 0) {
            var matchesCategory = categoryFilters.some(function(filterClass) {
              return $this.is('.' + filterClass);
            });
            if (!matchesCategory) {
              searchResult = false;
            }
          }
        }

        // var filter_dateto = $('.exhibitions-landing .exhibitions-filter__form select[name="date_to"]').val();
        // console.log('filter_dateto: ' + filter_dateto);


        var buttonResult = true;//buttonFilter ? $this.is( buttonFilter ) : true;
        return searchResult && buttonResult;



      }, 
      getSortData: {
        name: '[data-name]',
        date: '[data-publishdate]'      
      }
    });

      
  
    var iso = $grid.data('isotope'); // get Isotope instance

    function applyFiltersFromUrl() {
        prefillFiltersFromUrl();
        if ($grid && $grid.length) {
          $grid.isotope('arrange');
        }
    }

    function hasActiveResourceSearch() {
      var $form = $('.resources-landing .resources-filter__form');
      var keywordValue = ($form.find('input[name="keyword"]').val() || '').trim();
      var sortSelection = $sortSelect.length ? $sortSelect.val() : 'default';

      return keywordValue.length > 0 ||
        $form.find('input[type="checkbox"]:checked').length > 0 ||
        (sortSelection && sortSelection !== 'default');
    }

    function loadMore(toShow) {

      var filtersChosen = hasActiveResourceSearch();
      
      if (filtersChosen) {
        $(".resources-default-sliders").hide();
        $(".resources-grid").show();

      } else {
        $(".resources-default-sliders").show();
        $(".resources-grid").hide();
      }

      if (!$grid || $grid.length === 0) {
        return;
      }

      iso = $grid.data('isotope'); // get Isotope instance
      if (!iso || !iso.filteredItems) {
        return;
      }

      $grid.find(".hidden").removeClass("hidden");
      $grid.isotope('option', { sortBy: sortValue, sortAscending: sortAscending });
      $grid.isotope('arrange');
      var filteredIds = getFilteredResourceIds();
      queueResourceSessionUpdate(filteredIds);
      var allFilteredElems = $grid.isotope('getFilteredItemElements');
      if (!allFilteredElems || allFilteredElems.length === 0) {
        allFilteredElems = iso.filteredItems.map(function(item) {
          return item.element;
        });
      }

      var hiddenElems = allFilteredElems.slice(toShow, allFilteredElems.length);

      hiddenElems = Array.from(new Set(hiddenElems));
      $(hiddenElems).addClass('hidden');
      $grid.isotope('arrange');

      //when no more to load, hide show more button
      if (allFilteredElems.length <= toShow) {
        jQuery(".load-more").hide();
      } else {
        jQuery(".load-more").show();
      };

      updateResultsCount();
      equalizeResourceCardHeights();
    }

    var equalizing = false;
    function equalizeResourceCardHeights() {
      if (equalizing) return;
      equalizing = true;
      var $cards = $('.resources-grid__list .resource-card');
      if (!$cards.length) {
        equalizing = false;
        return;
      }
      $cards.css('min-height', '');
      var maxHeight = 0;
      $cards.each(function() {
        if (this.offsetHeight > maxHeight) {
          maxHeight = this.offsetHeight;
        }
      });
      if (maxHeight > 0) {
        $cards.css('min-height', maxHeight + 'px');
        if ($grid && $grid.data('isotope')) {
          $grid.isotope('layout');
        }
      }
      equalizing = false;
    }

    var equalizeResizeTimer;
    $(window).on('resize.resourcesEqualize', function() {
      clearTimeout(equalizeResizeTimer);
      equalizeResizeTimer = setTimeout(equalizeResourceCardHeights, 120);
    });

  var initShow = 12;
  var counter = initShow; //counter for load more button

  applyFiltersFromUrl();
  $grid.isotope();
  loadMore(initShow); //execute function onload


    function updateResultsCount() {
      var filteredElems = $grid.isotope('getFilteredItemElements');
      var visibleCount = $(filteredElems).not('.hidden').length;
      var totalCount = filteredElems.length;
      var resultsCount = document.getElementById('results-count');
      var resultsCountGroup = resultsCount ? resultsCount.closest('.results-count') : null;

      var resultsCountText = 'Showing ' + (new Intl.NumberFormat().format(visibleCount)) + ' matching ' + (visibleCount === 1 ? 'result' : 'results');

      if (resultsCount && resultsCountGroup) {
        if (hasActiveResourceSearch()) {
          resultsCount.innerText = resultsCountText;
          resultsCountGroup.classList.remove('is-count-hidden');
          resultsCountGroup.removeAttribute('aria-hidden');
        } else {
          resultsCount.innerText = '';
          resultsCountGroup.classList.add('is-count-hidden');
          resultsCountGroup.setAttribute('aria-hidden', 'true');
        }
      }

      var showButton = document.getElementById('resources-show-results');
      if (showButton) {
        showButton.textContent = 'Show (' + totalCount + ')';
        showButton.setAttribute('aria-label', 'Show ' + totalCount + ' results');
      }
    }
    updateResultsCount();


 //when load more button clicked
  $(".resources-landing .load-more a").click(function(e) {
    e.preventDefault();
    if ($('#filters').data('clicked')) {
      //when filter button clicked, set initial value for counter
      counter = initShow;
      $('#filters').data('clicked', false);
    } else {
      counter = counter;
    };

    counter = counter + initShow;

    loadMore(counter);
  });

    
  }

  export default initResources;
